import Keycloak from 'keycloak-js'

const keycloack = new Keycloak({
  url: 'https://sso.viacometa.com.br',
  realm: 'GC',
  clientId: 'cometa-leitura-spa'
})

export default keycloack
